/**
 * The context of the instance a sign-in started from, kept until profile setup
 * finishes so the sign-up it leads to can be credited there.
 *
 * It's kept in the tab's session storage, which survives the trip to a login
 * provider and back and doesn't reach other tabs.
 */

import type { EventContext } from './analytics';

const SIGN_IN_CONTEXT_KEY = 'psi-sign-in-context';

export function putSignInContext(context: Partial<EventContext>) {
    try {
        window.sessionStorage.setItem(SIGN_IN_CONTEXT_KEY, JSON.stringify(context));
    } catch {
        // Some third-party iframes block session storage.
    }
}

/** The context put by the last sign-in, removed as it is read. */
export function takeSignInContext(): Partial<EventContext> | null {
    try {
        const stored = window.sessionStorage.getItem(SIGN_IN_CONTEXT_KEY);
        window.sessionStorage.removeItem(SIGN_IN_CONTEXT_KEY);
        return stored ? JSON.parse(stored) : null;
    } catch {
        return null;
    }
}
